(angular => {

  angular.module("Pages", [

    ])
    .config(["$routeProvider", configRouter]);

  function configRouter($routeProvider) {

    $routeProvider
      .when("/dashboard", {
        controller: "Pages.dashboardCtrl",
        controllerAs: "$ctrl",
        templateUrl: `public/pages/dashboard/dashboard.html`,
        allowPreview: true
      })
      .when("/perfil", {
        controller: "Pages.perfilCtrl",
        controllerAs: "$ctrl",
        templateUrl: `public/pages/perfil/perfil.html`,
        allowAnonymous: true
      })
      .when("/perfil/:guestEmail", {
        controller: "Pages.perfilCtrl",
        controllerAs: "$ctrl",
        templateUrl: `public/pages/perfil/perfil.html`,
        allowAnonymous: true
      })
      .when("/certificado", {
        controller: "Pages.certificateCtrl",
        controllerAs: "$ctrl",
        templateUrl: `public/pages/certificate/certificate.html`,
        allowPreview: true
      })
      .when("/upload-manuais", {
        controller: "Pages.EventManualUploadCtrl",
        controllerAs: "$ctrl",
        templateUrl: `public/pages/eventManualUpload/list/list.html`,
        allowWithoutEvent: true
      })
      .when("/credencial", {
        controller: "Pages.credentialCtrl",
        controllerAs: "$ctrl",
        templateUrl: `public/pages/credential/credential.html`,
        allowPreview: true
      })
      .when("/voucher", {
        controller: "Pages.voucherCtrl",
        controllerAs: "$ctrl",
        templateUrl: `public/pages/voucher/voucher.html`,
        allowPreview: true
      })
      .when("/findRetailer", {
        controller: "Pages.findRetailerCtrl",
        controllerAs: "$ctrl",
        templateUrl: `public/pages/findRetailer/findRetailer.html`,
        allowAnonymous: true
      })
      .when("/archives", {
        controller: "Pages.archivesCtrl",
        controllerAs: "$ctrl",
        templateUrl: `public/pages/archives/archives.html`,
        allowAnonymous: true
      });
  }
})(angular);
